<template>
  <div>
    <el-dialog
      class="modal"
      width="375px"
      :visible.sync="addOrderModal"
      title="新增訂單"
    >
      <div class="modalBody">
        <p class="text-danger">注意!此操作不可逆請謹慎操作</p>
        <p>商戶號:{{ currentData.customer_id }}</p>
        <p>渠道:{{ addData.customer_method_id }}</p>
        <p>金額:{{ currentData.amount_total }}</p>
      </div>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="addOrderModal = false" class="btn">關閉</div>
        <div @click="confirmAddOrder" class="btn">確定</div>
      </div>
    </el-dialog>
    <el-form :inline="true" :model="addData" class="demo-form-inline">
      <el-form-item label="商戶號">
        <el-input
          v-model="addData.customer_id"
          @blur="getChannel(addData.customer_id)"
          placeholder="請輸入商戶號"
        ></el-input>
      </el-form-item>
      <el-form-item label="渠道">
        <el-select
          v-model="addData.customer_method_id"
          filterable
          placeholder="請選擇渠道"
        >
          <el-option
            v-for="channel in channelList"
            :key="channel.id"
            :value="channel.alias"
            :label="channel.alias"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="金額">
        <el-input
          v-model="addData.amount_total"
          placeholder="請輸入金額"
        ></el-input>
      </el-form-item>
      <el-form-item label="訂單號">
        <el-input v-model="addData.ct_id" placeholder="請輸入訂單號"></el-input>
        <p>(本訂單號由商戶生成，若商戶無提供請留空)</p>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="addOrder">新增訂單</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      user: {
        currency: {}
      },
      channelList: [],
      addData: {},
      addOrderModal: false,
      currentData: {}
    };
  },
  methods: {
    confirmAddOrder() {
      this.$http
        .post(`/back/collection/create/blank_transaction`, this.currentData)
        .then(res => {
          if (res.data.code == 0) {
            this.addData = {};
            this.$message.success("成功");
            this.addOrderModal = false;
          }
        });
    },
    addOrder() {
      if (!this.addData.customer_id) {
        this.$message.error("請輸入商戶號");
        return;
      }
      if (!this.addData.customer_method_id) {
        this.$message.error("請選擇渠道");
        return;
      }
      if (!this.addData.amount_total) {
        this.$message.error("請輸入金額");
        return;
      }
      let customer_method_id;
      this.channelList.forEach(e => {
        if (e.alias == this.addData.customer_method_id) {
          customer_method_id = e.id;
        }
      });
      this.currentData = {
        customer_method_id,
        customer_id: this.addData.customer_id,
        amount_total: this.addData.amount_total,
        ct_id: this.addData.ct_id,
        notify_url: "-",
        t_type: this.addData.channelMethod,
        type: 805
      };
      this.addOrderModal = true;
    },
    getChannel(id) {
      if (id == "" || id.length < 5) {
        return;
      }
      this.$http.get(`/back/collection/customer/${id}/methods`).then(res => {
        if (res.data.code == 0) {
          this.channelList = res.data.data;
          if (res.data.data.length) {
            this.user = res.data.data[0].currency;
          }
        }
      });
    }
  }
};
</script>
